export default {"src":"/_next/static/media/2imaging.3213a700.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};